module.exports = __webpack_public_path__ + "7507dc4bcac49749efbb5615e745dddf.png";